export const AB_TEST: Record<string, string> = {
  HIDE_REVIEWS_AB_TEST_NUMBER: '79',
  FEATURE_ENABLED_VALUE: '1',
  SHOW_DATABREAKERS_PRODUCTS: '62',
  SHOW_DATABREAKERS_PRODUCTS_2: '80',
  NEW_PD_DESIGN: '238',
  SHOW_PRODUCT_PICTOGRAMS: '236',
};
